import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, Spinner } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { log } from "@/lib/logger";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("missing"); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus("paid");
          refresh?.();
          return;
        }
      } catch (err) { log.warn("payment status poll failed", err); }
      if (attempts < 20 && !cancelled) setTimeout(poll, 1500);
      else if (!cancelled) setStatus("pending");
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen bg-[#F4F7FB] flex items-center justify-center p-6">
      <div className="bg-white border border-[#E1E9F0] rounded-2xl p-10 max-w-md w-full text-center">
        {status === "checking" && (
          <>
            <Spinner size={32} className="mx-auto text-[#3A8FA5] animate-spin mb-4" />
            <h1 className="font-serif text-2xl mb-2">Confirmation du paiement…</h1>
            <p className="text-sm text-[#5F758F]">Merci de patienter, ne fermez pas cette fenêtre.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle size={48} weight="fill" className="mx-auto text-[#3A8FA5] mb-4" />
            <h1 className="font-serif text-3xl mb-2">Merci !</h1>
            <p className="text-[#5F758F] mb-6">Votre abonnement Questiomed est actif. Un reçu vous a été envoyé par email.</p>
            <Link to="/dashboard">
              <Button className="rounded-md bg-[#1E3A5F] hover:bg-[#0F2340] text-white">Retour à l'accueil</Button>
            </Link>
          </>
        )}
        {status === "pending" && (
          <>
            <h1 className="font-serif text-2xl mb-2">Paiement en cours de traitement</h1>
            <p className="text-sm text-[#5F758F] mb-6">
              Nous n'avons pas encore reçu la confirmation de Stripe. Consultez votre email dans quelques minutes ou rafraîchissez la page Abonnement.
            </p>
            <Link to="/settings?tab=billing">
              <Button variant="outline" className="rounded-md">Voir mon abonnement</Button>
            </Link>
          </>
        )}
        {status === "missing" && (
          <>
            <h1 className="font-serif text-2xl mb-2">Session inconnue</h1>
            <p className="text-sm text-[#5F758F]">Le lien de paiement est invalide.</p>
          </>
        )}
      </div>
    </div>
  );
}
